
export const skillsData = [
  {
    name: "Reliability & Scalability (Platform Engineering)",
    value: 96,
    className: "bar-purple",
  },
  {
    name: "Full-Cycle Architecture (Full Stack)",
    value: 90,
    className: "bar-blue",
  },
  {
    name: "System Optimization & Bottleneck Analysis",
    value: 90,
    className: "bar-pink",
  },
  {
    name: "Cloud Integrity & DevOps Automation",
    value: 94,
    className: "bar-yellow",
  },
];
